import React, { useState } from "react";
import { Modal as Modal_ } from "antd";

export const Modal = ({ children, isOpen, toggleModal, title, className, footer, onOk }) => {
    return (
        <Modal_ visible={isOpen} onCancel={toggleModal} title={title} className={className} footer={footer} onOk={onOk}>
            {children}
        </Modal_>
    );
};
